import Image from "next/image";
import LandingHeadingText from "../ui/landing-heading-text";
import { useTranslations } from 'next-intl';

const LandingFeatures = () => {
    const t = useTranslations('landing');
    
    return (
        <div className='pt-[48px] lg:pt-[166px] pb-[93px] lg:pb-[195px] max-w-[90%] lg:max-w-[1300px] m-auto grid gap-[44px] lg:gap-[86.61px]'>
            <div className='grid max-w-[700px]'>
                <div className="flex items-center">
                    <Image src="images/zap.svg" alt="calendar" width={16} height={16} className="w-[16px] h-[16px]" />
                    <p className="text-[13px] poppins-bold text-grey-900">{t('featuresLabel')}</p>
                </div>
                <LandingHeadingText>{t('featuresHeading')}</LandingHeadingText>
            </div>
            <div className="grid gap-[33px]">
                <div className="w-full h-[680px] lg:h-[660px] rounded-[24px] bg-[#DFDFDF] pt-[51px] lg:pt-[37px] pl-[27px] lg:pl-[32px] grid content-between">
                    <div className="grid">
                        <p className="text-[32px] poppins-medium text-grey-900">{t('cleanerInboxTitle')}</p>
                        <p className="text-[16px] poppins-regular text-[#787490] max-w-[392px]">{t('cleanerInboxDesc')}</p>
                    </div>
                    <Image src='/images/landing-features-1.png' alt='cleaner inbox' width={847} height={509} className='ml-auto' />
                </div>
                <div className="grid lg:grid-cols-2 gap-[33px] w-full">
                    <div className="w-full h-[680px] lg:h-[730px] rounded-[24px] bg-[#DFDFDF] pt-[51px] lg:pt-[37px] px-[27px] lg:px-[32px] grid content-between">
                        <div className="grid">
                            <p className="text-[32px] poppins-medium text-grey-900">{t('smartRepliesTitle')}</p>
                            <p className="text-[16px] poppins-regular text-[#787490]">{t('smartRepliesDesc')}</p>
                        </div>
                        <Image src='/images/landing-features-2.png' alt='smart replies' width={564} height={575} className='m-auto' />
                    </div>
                    <div className="w-full h-[680px] lg:h-[730px] rounded-[24px] bg-[#DFDFDF] pt-[51px] lg:pt-[37px] pl-[27px] lg:pl-[32px] grid content-between">
                        <div className="grid pr-[27px] lg:pr-[32px]">
                            <p className="text-[32px] poppins-medium text-grey-900">{t('instantSummariesTitle')}</p>
                            <p className="text-[16px] poppins-regular text-[#787490]">{t('instantSummariesDesc')}</p>
                        </div>
                        <Image src='/images/landing-features-3.png' alt='smart replies' width={564} height={575} className='ml-auto' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingFeatures;
